import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

export interface AugerPurgeConfirmDialogData {
	summaryLines: string[];
}

@Component({
	selector: 'kt-auger-purge-confirm-dialog',
	templateUrl: './auger-purge-confirm-dialog.component.html'
})
export class AugerPurgeConfirmDialogComponent {
	constructor(
		public dialogRef: MatDialogRef<AugerPurgeConfirmDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: AugerPurgeConfirmDialogData
	) {}

	onConfirm(): void {
		this.dialogRef.close({ confirmed: true });
	}

	onCancel(): void {
		this.dialogRef.close({ confirmed: false });
	}
}
